module.exports = __webpack_public_path__ + "img/bn.33b0d66b.svg";